import React, { useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ChatStateContext } from '../../contexts/chatStateContext';

export function ChatsAsPage() {

  const chatState = useContext(ChatStateContext);
  const navigate = useNavigate();

  const { chatId } = useParams();

  useEffect(() => {
    if (!chatId) {
      navigate('/');
      return;
    }
    chatState.setCurrentChat(chatId);
  }, [chatId]);

  return null;
}